export const obtenerPorcentaje = ({valor, total}) => {

    if (total <= 0) {
        return 0
    }

    let porcentaje = 100 - ((100 * total) / valor)

    return 100 - porcentaje.toFixed(0)


}